import InsideepLogo from "../Icons/InsideepLogo";
 


function ErrorScreen({ error }: { error: any }) {
  return (
    <div
      style={{
        position: "absolute",
        width: "100%",
        height: "100%",
        padding: "8rem 10rem",
        boxSizing: "border-box",
      }}
    >
      <div>
        <InsideepLogo />
        <h2>Errore API</h2>
      </div>
      {error && (
        <div
          style={{
            maxHeight: "70%",
            overflowY: "auto",
          }}
        >
          <p>{error.message}</p>
          <p>{error.code}</p>
          <pre>{error.stack}</pre>
        </div>
      )}
    </div>
  );
}

export default ErrorScreen;
